import { RootState } from "@/modules/common";

export const selectOrder = (state: RootState) => state.orders;
